import { render, staticRenderFns } from "./footerBar.vue?vue&type=template&id=7000c126&scoped=true"
import script from "./footerBar.vue?vue&type=script&lang=js"
export * from "./footerBar.vue?vue&type=script&lang=js"
import style0 from "./footerBar.vue?vue&type=style&index=0&id=7000c126&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7000c126",
  null
  
)

export default component.exports